import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  DISTRIBUTIONS: 'distributions',
  INFORMATION: 'information',
  DEVICES: 'devices',
  ROLLOUTS: 'rollouts',
  DEVICE_BATCHES: 'device_batches',
};

// Exported paths
export const MAIN_PATH = PATHS.DISTRIBUTIONS;
export const INFORMATION_PATH = PATHS.INFORMATION;
export const DEVICES_PATH = PATHS.DEVICES;
export const ROLLOUTS_PATH = PATHS.ROLLOUTS;
export const DEVICE_BATCHES_PATH = PATHS.DEVICE_BATCHES;

// Root
const APP_DISTRIBUTIONS_PATH = `${APP_PATH}/${MAIN_PATH}`;

export const listPath = () => APP_DISTRIBUTIONS_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const addPath = () => `${APP_DISTRIBUTIONS_PATH}/add`;
export const navigateToAdd = () => {
  hashHistory.push(addPath());
};

export const showPath = (id) => `${APP_DISTRIBUTIONS_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/navigation.js